<template>
  <v-container>
    <v-row class="min-h-100vh">
      <v-col cols="12" justify="center" align="center">
        <h1>Bienvenido a equipamás</h1>
        <a :href="'mailto:ventas@equipamas.com'">
          <v-btn color="primary" class="mt-4">Contáctanos</v-btn>
        </a>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-img
          src="@/assets/Comunicaciones.webp"
          max-height="400"
          contain
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-img src="@/assets/Bomberos.webp" max-height="400" contain></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-img src="@/assets/Corte.webp" max-height="400" contain></v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-card
        class="mx-auto my-2"
        min-width="500"
        v-for="contacto in contactos"
        :key="contacto.phone"
      >
        <v-card-title>{{ contacto.title }}</v-card-title>

        <v-card-text class="text--primary">
          <div>
            Correo electrónico:
            <a :href="'mailto:' + contacto.email">{{ contacto.email }}</a>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
var domain = "@equipamas.com";
export default {
  name: "inConstruction",
  props: {
    msg: String,
  },
  data: () => ({
    contactos: [
      {
        title: "Ventas",
        email: "ventas" + domain,
      },
    ],
  }),
};
</script>
